import { useState } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Badge } from "@/components/ui/badge"
import { Building2, ChevronDown, Eye } from "lucide-react"
import { switchToDemo } from "@/services/onboarding"
import { useAuth } from "@/hooks/use-auth"

export function TenantSwitcher() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isDemo, setIsDemo] = useState(false)

  function handleSwitchToDemo() {
    switchToDemo()
      .then(() => {
        setIsDemo(true)
        queryClient.clear()
        navigate("/demo/dashboard")
      })
      .catch(() => {
        // Silently fail — demo mode is optional
      })
  }

  function handleSwitchToOrg() {
    const orgSlug = localStorage.getItem("lastOrgSlug") || "default"
    setIsDemo(false)
    queryClient.clear()
    navigate(`/${orgSlug}/dashboard`)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2 text-sm" data-test="tenant-switcher">
          <Building2 className="h-4 w-4" />
          <span className="max-w-[120px] truncate">
            {isDemo ? "Démo" : (user?.tenant_code || "Mon organisme")}
          </span>
          {isDemo && (
            <Badge variant="secondary" className="text-[10px] px-1.5 py-0">
              DEMO
            </Badge>
          )}
          <ChevronDown className="h-3.5 w-3.5 text-muted-foreground/60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuItem
          onClick={handleSwitchToOrg}
          className={!isDemo ? "bg-accent" : ""}
          data-test="switch-to-org"
        >
          <Building2 className="mr-2 h-4 w-4" />
          Mon organisme
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={handleSwitchToDemo}
          className={isDemo ? "bg-accent" : ""}
          data-test="switch-to-demo"
        >
          <Eye className="mr-2 h-4 w-4" />
          Démo (lecture seule)
          <Badge variant="secondary" className="ml-auto text-[10px] px-1.5 py-0">
            DEMO
          </Badge>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
